//
//  SDKDocumentationLegacyPageBlockType.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Source type enum
export var DocumentationLegacyPageBlockType;
(function (DocumentationLegacyPageBlockType) {
    DocumentationLegacyPageBlockType["text"] = "Text";
    DocumentationLegacyPageBlockType["heading"] = "Heading";
    DocumentationLegacyPageBlockType["code"] = "Code";
    DocumentationLegacyPageBlockType["unorderedList"] = "UnorderedList";
    DocumentationLegacyPageBlockType["orderedList"] = "OrderedList";
    DocumentationLegacyPageBlockType["quote"] = "Quote";
    DocumentationLegacyPageBlockType["callout"] = "Callout";
    DocumentationLegacyPageBlockType["divider"] = "Divider";
    DocumentationLegacyPageBlockType["image"] = "Image";
    DocumentationLegacyPageBlockType["token"] = "Token";
    DocumentationLegacyPageBlockType["tokenList"] = "TokenList";
    DocumentationLegacyPageBlockType["tokenGroup"] = "TokenGroup";
    DocumentationLegacyPageBlockType["shortcuts"] = "Shortcuts";
    DocumentationLegacyPageBlockType["link"] = "Link";
    DocumentationLegacyPageBlockType["figmaEmbed"] = "FigmaEmbed";
    DocumentationLegacyPageBlockType["youtubeEmbed"] = "YoutubeEmbed";
    DocumentationLegacyPageBlockType["storybookEmbed"] = "StorybookEmbed";
    DocumentationLegacyPageBlockType["genericEmbed"] = "Embed";
    DocumentationLegacyPageBlockType["figmaFrames"] = "FigmaFrames";
    DocumentationLegacyPageBlockType["custom"] = "Custom";
    DocumentationLegacyPageBlockType["renderCode"] = "RenderCode";
    DocumentationLegacyPageBlockType["componentAssets"] = "ComponentAssets";
    DocumentationLegacyPageBlockType["column"] = "Column";
    DocumentationLegacyPageBlockType["columnItem"] = "ColumnItem";
    DocumentationLegacyPageBlockType["tabs"] = "Tabs";
    DocumentationLegacyPageBlockType["tabItem"] = "TabItem";
    DocumentationLegacyPageBlockType["table"] = "Table";
    DocumentationLegacyPageBlockType["tableCell"] = "TableCell";
    DocumentationLegacyPageBlockType["tableRow"] = "TableRow";
    DocumentationLegacyPageBlockType["figmaComponentPropsTable"] = "FigmaComponentPropsTable";
    DocumentationLegacyPageBlockType["figmaComponents"] = "FigmaComponents";
    DocumentationLegacyPageBlockType["files"] = "Files";
})(DocumentationLegacyPageBlockType || (DocumentationLegacyPageBlockType = {}));
